import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container m-0 p-0" }
const _hoisted_2 = { class: "row m-1" }
const _hoisted_3 = { class: "col-12 col-lg-8" }
const _hoisted_4 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormBuilder = _resolveComponent("FormBuilder")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "col-0 col-lg-2" }, null, -1)),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isFormInactive)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "mt-4 p-3",
              innerHTML: _ctx.getInactiveMessage()
            }, null, 8, _hoisted_4))
          : (_openBlock(), _createBlock(_component_FormBuilder, {
              key: 1,
              lang: _ctx.lang,
              formStructure: _ctx.formStructure,
              formId: _ctx.formId,
              pageIndex: Number(_ctx.$route.query.page) || 0
            }, null, 8, ["lang", "formStructure", "formId", "pageIndex"]))
      ]),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "col-0 col-lg-2" }, null, -1))
    ])
  ]))
}